import React from 'react';
import useIntls from '@opm/hooks/useIntls';
import { TOptionsItem } from '../../types';

interface SingleSelectButtonProps {
  value: string;
  options: TOptionsItem[];
  title: string;
  titleCn: string;
  itemRender?: (item: TOptionsItem, isEn: boolean) => string | JSX.Element;
}

export const renderOptionItem = (
  item: TOptionsItem,
  isEn: boolean,
  itemRender?: (item: TOptionsItem, isEn: boolean) => string | JSX.Element,
) => {
  if (itemRender) {
    return itemRender(item, isEn);
  }
  return isEn ? item.text : item.textCn;
};

export function SingleSelectButton({
  value,
  options,
  title,
  titleCn,
  itemRender,
}: SingleSelectButtonProps) {
  const { isEn } = useIntls();

  const item = options.find((opt) => opt.value === value);
  const text = item ? renderOptionItem(item, isEn, itemRender) : '';

  return (
    <div className="dbom-dropdow-button">
      <label className="dbom-dropdow-button-label">
        {isEn ? title : titleCn}
      </label>
      <div className="dbom-dropdow-button-value">{text}</div>
    </div>
  );
}
